import React, { useState } from "react";
import Button from "../../../components/UI/Button";
import { validateEmail, websiteValidation } from "../../../utils/validation";

const WebsiteAnalysis = ({
  formUpload,
  userData,
  setUserWebsiteData,
  validationWebsite,
  scrapperError,
}) => {
  const [websiteError, setWebsiteError] = useState("");

  const handleWebsiteChange = (e) => {
    const value = e.target.value;
    setUserWebsiteData({
      ...userData,
      website: value,
    });

    if (!websiteValidation(value)) {
      setWebsiteError("Website must start with http or https");
    } else {
      setWebsiteError("");
    }
  };

  return (
    <div className="app-ai-quote-website" data-aos="fade-up">
      <div className="app-ai-quote-website-description">
        <h3>Upload Your Website link</h3>
        <p>
          Provide us with a link, and we&apos;ll create a sitemap momentarily.
        </p>
      </div>
      <form className="app-ai-quote-website-form">
        <div className="app-ai-quote-website-form-field">
          <label htmlFor="name">
            Name <span>*</span>
          </label>
          <input
            type="text"
            id="name"
            value={userData.name}
            onChange={(e) =>
              setUserWebsiteData({
                ...userData,
                name: e.target.value,
              })
            }
          />
          {validationWebsite.name && (
            <span className="app-ai-quote-website-error">Name is required</span>
          )}
        </div>
        <div className="app-ai-quote-website-form-field">
          <label htmlFor="email">
            Email <span>*</span>
          </label>
          <input
            type="email"
            id="email"
            value={userData.email}
            onChange={(e) =>
              setUserWebsiteData({
                ...userData,
                email: e.target.value,
              })
            }
          />
          {validationWebsite.email && (
            <span className="app-ai-quote-website-error">
              Email is required
            </span>
          )}
        </div>
        <div className="app-ai-quote-website-form-field">
          <label htmlFor="phone">
            Phone <span>*</span>
          </label>
          <input
            type="phone"
            id="phone"
            value={userData.phone}
            onChange={(e) =>
              setUserWebsiteData({
                ...userData,
                phone: e.target.value,
              })
            }
          />
          {validationWebsite.phone && (
            <span className="app-ai-quote-website-error">
              Phone is required
            </span>
          )}
        </div>
        <div className="app-ai-quote-website-form-field">
          <label htmlFor="website">
            Website <span>*</span>
          </label>
          <input
            type="text"
            id="website"
            value={userData.website}
            onChange={handleWebsiteChange}
          />
          {websiteError && (
            <span className="app-ai-quote-website-error">{websiteError}</span>
          )}
          {scrapperError && (
            <span className="app-ai-quote-website-error">{scrapperError}</span>
          )}
        </div>
      </form>
      <p>The estimate will be sent to your email address.</p>
      <p>Please note, the AI-generated quote may not be final as parsing could be affected by design specifics. The final estimate will be confirmed by your project manager after reviewing the designs and specifications.</p>
      <div className="app-ai-quote-website-button-group">
        <Button
          type="submit"
          onClick={formUpload}
          disabled={
            userData.name.length <= 2 ||
            !validateEmail(userData.email) ||
            userData.phone.length <= 2 ||
            !websiteValidation(userData.website)
          }
        >
          Analyze Now
        </Button>
        <p>
          Pressing this button indicates your consent <br />
          to our{" "}
          <a href="https://getdevdone.com/terms-and-conditions.html">
            Terms of Service
          </a>{" "}
          and{" "}
          <a href="https://getdevdone.com/privacy-policy.html">
            Privacy Policy
          </a>
          .
        </p>
      </div>
    </div>
  );
};

export default WebsiteAnalysis;
